module.exports = __webpack_public_path__ + "static/Canela-Thin-Web-fbd3c17a61f7f07bd1a85502c2cc4c85.woff2";